import React from 'react';
import { Button as LButton } from '@mui/material';
import { useTheme } from '@emotion/react';

export const Button = ({
  variant,
  children,
  color,
  startIcon,
  width,
  onClick,
  endIcon,
  style,
  padding,
  height,
  radius,
  minHeight,
  minWidth,
  disabled,
  loading,
  className,
  textColor,
  border,
  ...restProps
}) => {
  const theme = useTheme();
  const colorParts = color?.split('.');
  const isSimpleColor = colorParts?.length === 1;
  const isNestedColor = colorParts?.length === 2;
  const customColor =
    isNestedColor && theme.palette[colorParts[0]]?.[colorParts[1]]
      ? theme.palette[colorParts[0]][colorParts[1]]
      : null;
  return (
    <React.Fragment>
      <LButton
        sx={{
          borderRadius: radius ? radius : '8px',
          ...(border && { border: border ? border : 'none' }),
          textTransform: 'none',
          height: height ? height : '',
          ...(width && { width: width }),
          fontSize: '16px',
          padding: padding ? padding : '0px 8px',
          minWidth: minWidth ? minWidth : 'max-content',
          minHeight: minHeight ? minHeight : '44px',
          letterSpacing: '2.4px',
          ...(customColor && {
            backgroundColor: customColor,
            ":hover": { backgroundColor: customColor === "#CBEEDC" ? '#B5E0CA' : customColor === '#000000' ? '#404040' : ''},
            color: textColor || '#FFFFFF'
          })
        }}
        size='small'
        variant={variant}
        startIcon={startIcon}
        onClick={disabled ? null : onClick}
        endIcon={endIcon}
        color={isSimpleColor ? color : undefined}
        style={style}
        disabled={disabled}
        className={className}
        {...restProps}
      >
        {loading ? (
          <div
            className={`w-14 h-[22.9px] animate-dots`}
            style={{
              color: isSimpleColor ? colorParts[0] : isNestedColor ? colorParts[1] : textColor
            }}
          ></div>
        ) : (
          children
        )}
      </LButton>
    </React.Fragment>
  );
};
